const LoadingFileUpload = () => {
  return (
    <div
        className={`w-35 relative flex h-full cursor-pointer items-center justify-center overflow-hidden border  border-input bg-[#f4f4f4]`}
    >
    <div className="customfileuploaderloader">
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
        <div className="block"></div>
    </div>
    </div>
  )
}

export default LoadingFileUpload